import React from 'react'
import { action } from '@storybook/addon-actions'
import { storiesOf } from '@storybook/react'

import { MatchEventType } from 'protos'

import Grid from '@material-ui/core/Grid'

import TimelineItem from 'components/TimelineItem'

storiesOf('TimelineItem', module)
  .addDecorator((story) => (
    <Grid container>
      <Grid item xs={12}>
        {story()}
      </Grid>
    </Grid>
  ))
  .add('default', () => (
    <TimelineItem />
  ))
  .add('system event', () => (
    <TimelineItem timestamp={Math.round(Date.now() / 1000)} type={MatchEventType.ET_ADM_MATCH_STARTED} />
  ))
  .add('team event', () => (
    <>
      {[
        <TimelineItem key="1" clock={{ minute: 55 }} type={MatchEventType.ET_CORNER} value={2} reverse />,
        <TimelineItem key="2" clock={{ minute: 45, extra: 3 }} type={MatchEventType.ET_CORNER} value={2} />
      ]}
    </>
  ))
  .add('player event', () => (
    <>
      {[
        (
          <TimelineItem
            key="1"
            type={MatchEventType.ET_SAVE}
            name="Courtois"
            clock={{ minute: 45, extra: 3 }}
            value={10}
            jersey={{ jerseyNumber: '1', baseColor: 'F4911E', sleeveColor: 'E4911E' }}
            onClick={action('onClick')}
          />
        ),
        (
          <TimelineItem
            key="2"
            type={MatchEventType.ET_SHOT_ON_GOAL}
            name="C. Ronaldo"
            clock={{ minute: 45, extra: 3 }}
            value={5}
            jersey={{ jerseyNumber: '7', baseColor: 'FF0000', sleeveColor: 'EE0000' }}
            onClick={action('onClick')}
            reverse
          />
        ),
        (
          <TimelineItem
            key="3"
            type={MatchEventType.ET_YELLOW_CARD}
            name="Hazard"
            clock={{ minute: 1 }}
            value={-5}
            jersey={{ jerseyNumber: '10', baseColor: '034694', sleeveColor: '034684' }}
            onClick={action('onClick')}
          />
        )
      ]}
    </>
  ))
